<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>部门管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">部门列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="部门名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入部门名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button @click="getList()" class="btn">查询</el-button>
                  <el-button @click="resetForm1('ruleForm')">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button class="btn" style="margin-bottom: 16px" @click="add()"
          >添加</el-button
        >
        <el-table
          :data="tableData"
          style="width: 100%"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          row-key="id"
        >
          <el-table-column prop="name" label="部门名称" align="center">
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">停用</span>
              <span class="greenColor" v-if="scope.row.status == 1">启用</span>
            </template>
          </el-table-column>
          <el-table-column prop="gmtCreate" label="创建时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  停用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </div>
                <div class="operateBtn" @click="edit(scope.row)">编辑</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="部门名称" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入部门名称"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="上级部门" prop="pid">
          <el-cascader
            :props="cateProps"
            :show-all-levels="false"
            v-model="selectData"
            :options="selectList"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        name: "",
        region: "",
      },
      tableData: [],
      dialogFormVisible: false,
      ruleForm1: {
        name: "",
        pid: "",
      },
      rules: {
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        pid: [{ required: true, message: "必选项", trigger: "change" }],
      },
      selectList: [],
      title: "添加部门",
      editId: "",
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      selectData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleChange(val) {
      this.ruleForm1.pid = val[val.length - 1];
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm1(formName) {
      this.ruleForm.name = "";
      this.selectData = [];
      this.getList();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            name: this.ruleForm1.name,
            pid: this.ruleForm1.pid,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/division/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.ruleForm.name = "";
                this.selectData = [];
              });
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/division/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";

                this.ruleForm.name = "";
                this.selectData = [];
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    edit(val) {
      this.ruleForm1.name = val.name;
      this.ruleForm1.pid = val.pid;
      this.selectData = [val.pid];
      this.editId = val.id;
      this.title = "编辑部门";
      let arr = Object.assign([], this.tableData);
      arr.push({
        id: 0,
        name: "顶级",
      });
      this.selectList = arr;
      this.dialogFormVisible = true;
    },
    add() {
      this.ruleForm1.name = "";
      this.ruleForm1.pid = "";
      this.title = "添加部门";
      let arr = Object.assign([], this.tableData);
      arr.push({
        id: 0,
        name: "顶级",
      });
      this.selectList = arr;
      this.dialogFormVisible = true;
    },
    getList() {
      let param = {
        page: 1,
        pageSize: 1000,
        queryParams: [
          { name: "name", type: "input", value: this.ruleForm.name },
        ],
      };
      this.$axios
        .post(`/admapi/division/treelist`, param)
        .then(({ data }) => {
          this.tableData = data;
        })
        .catch()
        .finally();
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/division/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "启用成功" : "禁用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleDelete(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/division/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
